import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import "../assets/css/MovieList.css";

const MovieList = () => {
  const [movies, setMovies] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/movies/getMovies`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((result) => {
        setMovies(result.movies);
      })
      .catch((error) => {
        console.log(error);
        setMovies([]);
      });
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1 className="my-4">Watch Movies Online</h1>
          <div className="container">
            <div className="row justify-content-end">
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Movies"
                />
                <div className="input-group-append">
                  <button className="btn btn-danger" type="button">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        {movies.map((movie, index) => (
          <div className="col-md-4 mb-4" key={index}>
            <div className="card movie-card position-relative">
              <img
                src={movie.image}
                className="card-img-top"
                alt={movie.title}
              />
              <div className="card-body">
                <h5 className="card-title">{movie.title}</h5>
                <h6 className="card-subtitle mb-2 text-muted">{movie.genre}</h6>
                <h6 className="card-subtitle mb-2 text-muted">
                  Release: {movie.year}
                </h6>
              </div>
              <div className="card-hover position-absolute w-100 h-100">
                <Button
                  variant="none"
                  className="text-white w-100 h-100"
                  style={{ top: 0, left: 0 }}
                >
                  View Details
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MovieList;
